const linkPalette = (tokens) => {
    return {
        font: {
            family: tokens.linkFontFamily,
            weight: tokens.linkFontWeight,
            letterSpacing: tokens.linkLetterSpacing,
            caption: {
                size: tokens.linkFontSizeCaption,
                lineHeight: tokens.linkLineHeightCaption
            },
            default: {
                size: tokens.linkFontSizeDefault,
                lineHeight: tokens.linkLineHeightDefault
            }
        },
        background: {
            default: tokens.linkColorBgDefault,
            hover: tokens.linkColorBgHover,
            focus: tokens.linkColorBgFocus,
            disabled: tokens.linkColorBgDisabled
        },
        text: {
            default: tokens.linkColorTextDefault,
            hover: tokens.linkColorTextHover,
            focus: tokens.linkColorTextFocus,
            disabled: tokens.linkColorTextDisabled,
            visited: tokens.linkColorTextVisited
        }
    };
};
export default linkPalette;
//# sourceMappingURL=link.js.map